import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { CommonModule } from '@angular/common';
import { StateFooterComponent } from './state-footer';

@NgModule({
  declarations: [
    StateFooterComponent,
  ],
    imports: [
    CommonModule,
    IonicModule
  ],
  exports: [
    StateFooterComponent
  ]
})
export class StateFooterComponentModule {}


// WEBPACK FOOTER //
// ./src/components/state-footer/state-footer.module.ts